
const DEPLOYMODE = process.env.REACT_APP_DEPLOYMODE;

// 環境変数DEPLOYMODEがdevelopmentの時のみconsole.logを出力する
export function consoleLog(message) {
  if(DEPLOYMODE === 'development') {
    console.log(message)
  }
}